<template>
  <div class="search">
    <b-row class="no-gutters">
      <b-col cols="8" class="pt-2">
        <h4>Buscador</h4>
      </b-col>
      <b-col class="mt-2 mb-2 mr-2 text-right">
        <a href="#" class="btn btn-secondary">Buscar</a>
      </b-col>
    </b-row>
    <b-row class="no-gutters">
      <b-col>
        <b-form inline>
          <b-row class="no-gutters">
            <b-col cols="12">
              <label for="search-tipo">Tipo</label>
              <b-form-select id="search-tipo" size="sm" class="ml-2 mr-2 mb-2">
                <b-form-select-option value="3">Vehículo</b-form-select-option>
                <b-form-select-option value="4">Moticicleta</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col cols="12" sm="6">
              <label for="search-marca">Marca</label>
              <b-form-select id="search-marca" size="sm" class="ml-2 mr-2 mb-2">
                <b-form-select-option value="3">Toyota</b-form-select-option>
                <b-form-select-option value="4">Honda</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col cols="12" sm="6">
              <label for="search-linea">Línea</label>
              <b-form-select id="search-linea" size="sm" class="ml-2 mr-2 mb-2">
                <b-form-select-option value="3">Corolla</b-form-select-option>
                <b-form-select-option value="4">RAV4</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col cols="12" sm="6">
              <label for="search-base-from">Precio base</label>
              <b-input id="search-base-from" size="sm" type="text" class="ml-2 mr-2 mb-2" />
            </b-col>
            <b-col cols="12" sm="6">
              <label for="search-base-to">A</label>
              <b-input id="search-base-to" size="sm" type="text" class="ml-2 mr-2 mb-2" />
            </b-col>
            <b-col cols="12" sm="6">
              <label for="search-anyo-from">Modelo</label>
              <b-input id="search-anyo-from" size="sm" type="text" class="ml-2 mr-2 mb-2" />
            </b-col>
            <b-col cols="12" sm="6">
              <label for="search-anyo-to">A</label>
              <b-input id="search-anyo-to" size="sm" type="text" class="ml-2 mr-2 mb-2" />
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Search"
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.search {
  .btn {
    text-transform: uppercase;
  }
}

form {
  font-size: 0.9rem;

  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 0.8rem;
  }

  > .row {
    > div[class^="col-"],
    div[class*=" col-"] {
      display: flex;

      > * {
        flex: 1 0 auto;
      }

      > label {
        justify-content: left;
      }

      > input {
        max-width: 150px;

        @media (max-width: prev-viewport-max-size("xl")) {
          max-width: 100px;
        }

        @media (max-width: prev-viewport-max-size("lg")) {
          max-width: 70px;
        }
      }

      > input,
      > select {
        flex-grow: 30;
        font-size: 0.7rem;

        @media (max-width: prev-viewport-max-size("md")) {
          max-width: initial;
          width: auto;
        }
      }
    }
  }
}
</style>